/* unplugin-vue-components disabled */import { render } from "./comp3.vue?vue&type=template&id=49884224&scoped=true"
import script from "./comp3.vue?vue&type=script&lang=js"
export * from "./comp3.vue?vue&type=script&lang=js"

import "./comp3.vue?vue&type=style&index=0&id=49884224&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49884224"]])

export default __exports__